import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { RutasDidacticasList } from "../RutasDidacticasComp";
import { SalasListFree } from "../SalasCmpfree";
import { EducaAdd } from "../../Shared";
import "./TeacherSalasGridfree.scss";

export function TeacherSalasGridfree(props) {
  const {
    teacher,
    selectedClass,
    accessToken,
    page,
    setPage,
    reload,
    onReload
  } = props;

  const [showAd, setShowAd] = useState(false);
  const ad = {
    type: "image-text",
    src: "https://mi-cdn.com/banner.jpg",
    title: "¡Prueba Premium!",
    description: "Más funcionalidades sin anuncios.",
    ctaText: "Descubrir",
    ctaLink: "https://educa360.com/store/plan-educa-creator-anual",
  };

  return (
    <div className="teacher-salas-grid">
      {/* Columna Izquierda (80%) */}
      <div className="teacher-salas-grid__left">
        <SalasListFree
          classNumber={selectedClass}
          teacher={teacher}
          currentPage={page}
          onPageChange={setPage}
          onTotalPagesChange={() => {}}
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Columna Derecha (20%) */}
      <div className="teacher-salas-grid__right">
        <div className="teacher-salas-grid__top">
          <Button
            primary
            onClick={() => setShowAd(true)}
            style={{ marginBottom: "1rem", justifyContent: "center" }}
          >
            Nueva Ruta
          </Button>
          <EducaAdd
            open={showAd}
            onClose={() => setShowAd(false)}
            adData={ad}
            size="tiny"
          />
          <RutasDidacticasList
            teacherId={teacher?._id}
            teacher={teacher}
            classNumber={selectedClass}
            accessToken={accessToken}
            reload={reload}
          />
        </div>
      </div>
    </div>
  );
} //
